<template>
    <el-dialog class="send-dialog" title="推送待办人" width="400px" :visible.sync="visible" :close-on-click-modal="false" :before-close="close">
        <div>
            <el-form :model="ruleForm" :rules="rules" ref="ruleForm" label-width="90px">
                <el-form-item label="MIP账号" prop="mipCode">
                    <el-input readonly placeholder="MIP账号" clearable v-model="ruleForm.mipName">
                        <el-button slot="append" icon="el-icon-search" @click="openPersonDialog"></el-button>
                    </el-input>
                </el-form-item>
            </el-form>
        </div>
        <span slot="footer" class="dialog-footer">
            <el-button @click="close">取 消</el-button>
            <el-button type="primary" :loading="loading" @click="handleConfirm">确 定</el-button>
        </span>
        <PersonLimit
            v-if="showPerDialog"
            :append-to-body="true"
            :config="perConfig"
            :limit="5"
            @closePerDialog="closePerDialog"
            @confirmPerDialog="confirmPerDialog"
            @before-close="closePerDialog"></PersonLimit>
    </el-dialog>
</template>

<script>
import lsrmapi from '../../../api/contract/warningTask';
import PersonLimit from '../../../components/personOne/PersonLimit.vue'

const INIT_FORM = {
    mipCode: '',
    mipName: '',
}

const RULES = {
    mipCode: [{ required: true, message: '请选择MIP账号', trigger: ['blur', 'change'] }],
}

export default {
    components: { PersonLimit },
    props: {
        title: {
            type: String,
            default() {
                return '';
            }
        },
    },
    data() {
        return {
            showPerDialog: false,
            perConfig: {
                // 框架人员选择的配置
                title: '添加成员',
                showDialog: false,
                selectList: [],
                value: '',
                tree: {
                    key: 'code',
                    defaultProps: {
                        children: 'children',
                        label: 'name',
                    },
                },
                operation: [
                    {
                        label: '取 消',
                        Event: 'closePerDialog',
                    },
                    {
                        label: '确 定',
                        Event: 'confirmPerDialog',
                        type: 'primary',
                    },
                ],
            },
            visible: false,
            loading: false,
            ruleForm: { ...INIT_FORM },
            rules: { ...RULES },
            selectedData: [], // 已勾选数据
        };
    },
    methods: {
        close() {
            this.selectedData = []
            this.visible = false
            this.ruleForm = { ...INIT_FORM }
            this.$nextTick(() => {
                this.$refs['ruleForm'].clearValidate()
            })
        },
        open(selectedData) {
            this.selectedData = selectedData || []
            this.visible = true
        },
        handleConfirm() {
                this.$refs.ruleForm.validate().then(valid => {
                this.loading = true
                lsrmapi.pushBacklog({mipCodeList: this.ruleForm.mipCode.split(','), contractCodeList: this.selectedData.map(v => v.contractCode)}).then(res => {
                    if (res && +res.code === 0) {
                        this.$message.success('推送成功!')
                        this.$emit('reload')
                        this.close()
                    }
                }).finally(() => { this.loading = false })
            }).catch(err => {})
        },
         // 打开内部人员菜单
         openPersonDialog() {
            this.showPerDialog = true
            this.perConfig.selectList = []
            setTimeout(() => {
                this.perConfig.showDialog = true
                this.perConfig.selectList = this.ruleForm.mipCode ? this.ruleForm.mipCode.split(',').map((v, i) => {
                    return {
                        userCode: v,
                        userName: this.ruleForm.mipName.split(',')[i]
                    }
                }) : []
            }, 100)
        },
        // 保存选择框架人员信息
        confirmPerDialog(data) {
            const selected = [...data.selectList]
            this.ruleForm.mipCode = selected.map(v => v.userCode) + ''
            this.ruleForm.mipName = selected.map(v => v.userName) + ''
            this.perConfig.showDialog = false
            this.showPerDialog = false
            this.perConfig.selectList = []
        },
        // 关闭内部人员菜单
        closePerDialog() {
            this.perConfig.showDialog = false
            this.showPerDialog = false
        },
    },
    mounted() { }
};
</script>
<style lang="less">
.send-dialog {
    .el-form-item__content .el-input-group {
        vertical-align: middle;
    }
}
</style>